module.exports = '<svg width="27" height="32" viewBox="0 0 27 32"><path d="M17.239 13.408a3.83 3.83 0 1 1-7.661 0 3.83 3.83 0 0 1 7.661 0zM13.408 0C6.014 0 0 6.017 0 13.408c0 7.752 8.097 15.295 11.665 18.109.408.322 1.201.483 1.743.483.567 0 1.329-.172 1.747-.519 3.457-2.86 11.661-10.451 11.661-18.073C26.816 6.016 20.801 0 13.408 0zm0 21.07c-4.231 0-7.662-3.433-7.662-7.662s3.431-7.662 7.662-7.662 7.662 3.433 7.662 7.662-3.431 7.662-7.662 7.662z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/location-pin-3.js
// module id = 1240
// module chunks = 14